import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const LedMonitoring = () => {
  const [ledData, setLedData] = useState([]);
const [isLoading, setIsLoading] = useState(false);

const authToken = localStorage.getItem("access");

 const fetchLedMonitoring = async () => {
  try {
    setIsLoading(true);

    const response = await fetch(
      "https://api.hanoch.in/performance/api/led-monitoring/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      setLedData(data);
    } else if (response.status === 401) {
      localStorage.removeItem("access");
    } else {
      console.error("Failed to fetch LED monitoring data");
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    setIsLoading(false);
  }
};

 useEffect(() => {
  fetchLedMonitoring();

  // Refresh every 5 seconds (optional)
  const interval = setInterval(fetchLedMonitoring, 5000);

  return () => clearInterval(interval);
}, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Led Monitoring" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                 
                </CardHeader>

                <CardBody>
  {/* {isLoading ? (
    <div className="text-center py-4">Loading...</div>
  ) : ( */}
    <Row>
      {ledData.map((item, index) => (
        <Col lg={3} md={4} sm={6} xs={12} key={index} className="mb-3">
          <Card className="shadow-sm border">
            <CardBody className="d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-1 text-capitalize">{item.name}</h6>

                <small className="text-muted">
                  {new Date(item.updated_at).toLocaleString()}
                </small>
              </div>

              <div
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  backgroundColor: item.value === 1 ? "#28a745" : "#dc3545",
                  boxShadow:
                    item.value === 1
                      ? "0 0 10px #28a745"
                      : "0 0 10px #dc3545",
                  border: "2px solid #fff",
                }}
              />
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  {/* )} */}
</CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    
     
    </React.Fragment>
  );
};

export default LedMonitoring;
